<script lang="ts">
  import { ExternalLink } from "lucide-svelte";

  export let crossLinks: { text: string; href: string }[];
  export let crossLinksText: string = "See it in action";
</script>

<div
  class="border border-c-pale-green-100 rounded-lg bg-c-pale-green-10 p-3 mt-10 space-y-1"
>
  <div class="text-white text-sm mb-2">
    {crossLinksText}
  </div>
  {#each crossLinks as { text, href } (href)}
    <div class="text-sm text-c-gray-80">
      <a target="_blank" rel="noreferrer" {href} class="hover:underline">
        <span>{text}</span><ExternalLink
          size={16}
          class="inline-block ml-1.5 mb-1"
        />
      </a>
    </div>
  {/each}
</div>
